<template>
  <review-item :tag="tag" v-bind="$attrs">
    <div class="d-flex flex-column align-start">
      <div class="primary--text t-5">
        <strong>{{ $t("wizard.review." + tag) }}</strong>
      </div>
      <div class="review-item-content-wrap">
      <div :class="{'review-item-content t-2': true, 'ml-4': !isMobile}" v-text="value" />
      </div>
    </div>
  </review-item>
</template>

<style lang="scss" scoped>
.review-item-content-wrap {
  max-height: 300px;
  white-space: pre-wrap;
  overflow-y: hidden;

  .review-item-content {
  }
}
</style>

<script lang="ts">
import Vue from "vue";
import ReviewItem from "./ReviewItem.vue";

export default Vue.extend({
  components: {
    ReviewItem
  },
  props: {
    tag: {
      type: String,
      required: true
    },

    value: {
      type: String,
      required: true
    }
  },
  computed: {
    isMobile(): boolean {
      // True when the viewport is under the breakpoint for mobile behavior
      return this.$vuetify.breakpoint.smAndDown;
    },
  }
});
</script>
